import { apiUrl } from "@/lib/api";

export type AcoustidMatch = {
  title: string;
  artist: string;
};

type AcoustidResponse = {
  match?: AcoustidMatch | null;
  error?: string;
};

const MAX_MP3_BYTES = 100 * 1024 * 1024;

export async function identifyLocalMp3(file: File): Promise<AcoustidMatch | null> {
  if (file.size > MAX_MP3_BYTES) {
    throw new Error("This MP3 exceeds the 100 MB recognition limit.");
  }

  const response = await fetch(apiUrl("/api/acoustid/identify"), {
    method: "POST",
    headers: { "Content-Type": "audio/mpeg" },
    body: file,
    credentials: "include",
  });
  const payload = (await response.json().catch(() => null)) as AcoustidResponse | null;

  if (!response.ok) {
    throw new Error(payload?.error || "Music recognition failed.");
  }

  return payload?.match ?? null;
}
